const FilterbarPart = ({ where, children }) => {

  return <div className={where}>
    {children}
  </div>
}

export default FilterbarPart
